var map = {
	"./ultimate-capsule-wardrobe-guide.jpg": "5dFr",
	"./vacation-capsule-wardrobe-for-men-800x534.jpg": "m0hQ",
	"./vacation-capsule-wardrobe-for-men.jpg": "FQ4r"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+OyP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog ^\.\/.*$
// module id = +OyP
// module chunks = 0